//Imports node_modules
import React, { useContext, useEffect, useState, useCallback } from 'react'
import Modal from 'react-modal';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


//Imports Css
import './ZonePage.css'

//Import Components
import CttCard from '../../../components/layout/cttCard/CttCard';
import TopBar from '../../../components/Global/topBar/TopBar';


//Import Data
import { globalVariables } from '../../../data/GlobalVariables'
import { globalModals } from '../../../data/GlobalModals'
import { axiosCalls } from '../../../data/AxiosCalls';


//Pagina onde o cliente selciona a entidade
const ZonePage = (props) => {

    //--- Variaveis

    //Variaveis Locais
    const {
        apiBaseUrl,
        ResetPe,
        setZone,
        pe,
        setCloseProductionRedirectionVars
    } = useContext(globalVariables)

    const {
        ShowMessageModal,
    } = useContext(globalModals);

    const {
        AxiosPost
    } = useContext(axiosCalls)

    const queryParams = new URLSearchParams(window.location.search);

    const cookies = new Cookies();

    const [response, setResponse] = useState([])

    const navigate = useNavigate();

    //--- Fim variaveis 

    //--- Funções

    //----- Funções Top Bar  
    function nextBtnClick() {
    }

    function backbtnClick() {
        ResetPe();
        var date = new Date();
        date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
        var emptyObject = []
        localStorage.setItem('storedGroupMembers', JSON.stringify(emptyObject));
        navigate('/userPage')
    }

    //----- Fim Funções Top Bar  

    const currentZone = useCallback(function (zone) {

        //Verifica se ele pode iniciar produção nesta zona 
        //Por regra ele só pode ter produção numa zona 
        Object.keys(response).forEach(function (form, indexZona) {
            if (response[indexZona].nctt === zone.nctt) {
                if (response[indexZona].productionCount > 0) {
                    if (zone.nctt !== undefined && zone.nctt !== null && pe.npe !== undefined && pe.npe !== null) {
                        //Pode continuar para pagina de finalização
                        AxiosPost(('Production/getObraByUserAndZone?nctt=' + zone.nctt + '&npe=' + pe.npe), 'message', 'Não foi encontrada a obra em produção', function comutereponse(responseoObra) {
                            //set obra
                            setCloseProductionRedirectionVars(pe, zone, responseoObra.data[0])
                            navigate('/productionPage?auto=true')
                        });
                    } else {
                        ShowMessageModal(
                            {
                                modaltype: 'error',
                                modalTitle: 'Erro ao chamar a base de dados',
                                modalMessage: 'Não foi possível comunicar com o servidor, por favor tente de novo. Caso o problema persista entre em contacto com o administrador.',
                                nextClick: 'dismiss',
                                nextBtnTxt: 'Compreendi',
                                crossClick: 'dismiss',
                            });
                    }
                } else {
                    var found = false;
                    //Verifica se existe alguma produção numa zona para alem da selecionada
                    Object.keys(response).forEach(function (form, indexZonaInner) {
                        if (response[indexZonaInner].nctt !== zone.nctt) {
                            if (response[indexZonaInner].productionCount > 0) {
                                found = true;
                            }
                        }
                    });

                    if (found) {
                        //manda um alerta
                        toast.warn('Já existe uma produção em curso para o funcionário escolhido!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        setZone(zone);
                        if (pe === 'empty' || pe.npe === 0) {
                            navigate('/groupProductionPage')
                        } else {
                            navigate('/productionWorkListPage')
                        }
                    }
                }
            }
        });

        // eslint-disable-next-line
    }, [verefyObraStatus, setZone])

    function verefyObraStatus(zone) {
        navigate('/productionWorkListPage')
    }

    function getUserList(states) {
        //Caso tenha apenas um ele passa á frente
        if (queryParams.get('back') && states.length === 1) {
            ResetPe();
            var emptyObject = []
            localStorage.setItem('storedGroupMembers', JSON.stringify(emptyObject));
            navigate('/userPage')
        }

        if (!queryParams.get('back') && states.length === 1) {
            setZone(states[0]);
            verefyObraStatus(states[0]);
        } else {
            return states.map((state, index) =>
                <CttCard key={index} ctt={state} onClick={currentZone}></CttCard>
            )
        }
    }

    useEffect(() => {
        //Query para ler os funçionarios/grupos que o dispositivo tem acesso
        axios.post((apiBaseUrl + 'Zones/verefyZoneAndUserProduction?uniqueId=' + cookies.get('uniqueDeviceID') + '&npe=' + pe.npe), { timeout: 50000 }).then((response) => {
            const isDataAvailable = response.data && response.data.length;
            if (isDataAvailable) {
                const myJSON = JSON.stringify(response.data);
                if (myJSON.slice(0, 6) === '"Erro:') {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Erro a ler os centro de trabalho',
                            modalMessage: response.data,
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                        })
                } else {
                    //Operação a executar
                    setResponse(response.data);
                }
            } else {
                ShowMessageModal(
                    {
                        modaltype: 'info',
                        modalTitle: 'Acessos em falta',
                        modalMessage: 'O administrador ainda não deu permissão a nenhum opção neste dispositivo'
                    });
            }
        }, (error) => {
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro a ler as opções',
                    modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        });

        // eslint-disable-next-line
    }, [apiBaseUrl]);

    //--- Fim funções

    //Para não dar erro no modal
    Modal.setAppElement('body');

    return (
        <div className="ZonePage">
            <div className='topbar'>
                <TopBar texto='Escolha a zona:' type='blue' backText='Voltar' nextBtnClick={nextBtnClick} backbtnClick={backbtnClick} layout='1'></TopBar>
            </div>
            <div className="pageContent" style={{ position: 'fixed' }}>
                <div className='flexLayoutScrollable' style={{ marginTop: '54px' }}>
                    {getUserList(response)}
                </div>
            </div>

            <div className="footer" style={{ borderTop: '0px', height: '100px' }}>
                {/* No futuro criar um componente para isto*/}
                <div className='backgroundCard' style={{ marginTop: '20px', marginRight: '70px', marginLeft: '70px' }}>
                    <div className="container" >
                        <div className="row" >
                            <div className="col-sm-6" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <h4 style={{ fontSize: '18px' }}>
                                    <svg style={{ isolation: 'isolate' }} viewBox="0 0 128 155" width="14px" height="14px">
                                        <defs>
                                            <clipPath id="_clipPath_O2hh1Xg8DIDgfn5Y0Ybfs5Gk4Ccf3OYo">
                                                <rect width="154" height="153" />
                                            </clipPath>
                                        </defs>
                                        <g clipPath="url(#_clipPath_O2hh1Xg8DIDgfn5Y0Ybfs5Gk4Ccf3OYo)">
                                            <path d=" M 7.635 11.204 C 10.67 6.404 14.824 6.073 19.194 6.077 C 57.045 6.11 94.896 6.052 132.747 6.147 C 142.744 6.172 145.32 8.817 145.335 18.748 C 145.394 56.599 145.392 94.45 145.337 132.301 C 145.322 142.74 142.211 145.898 131.657 145.924 C 94.372 146.012 57.085 146.033 19.8 145.935 C 9.105 145.906 6.498 142.881 6.517 132.163 C 6.583 96.007 6.564 59.851 6.641 23.696 C 6.649 19.759 7.07 15.823 7.635 11.204 Z " fill="rgb(198,60,52)" />
                                        </g>
                                    </svg>
                                    <strong>&nbsp;Produção a decorrer</strong>
                                </h4>
                            </div>
                            <div className="col-sm-6" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <h4 style={{ fontSize: '18px' }}>
                                    <svg style={{ isolation: 'isolate' }} viewBox="0 0 128 155" width="14px" height="14px">
                                        <defs>
                                            <clipPath id="_clipPath_2HOmmpTmYRdcOaZY3DY0wSAY4RUsgzFO">
                                                <rect width="128" height="155" />
                                            </clipPath>
                                        </defs>
                                        <g clipPath="url(#_clipPath_2HOmmpTmYRdcOaZY3DY0wSAY4RUsgzFO)">
                                            <path d=" M 9.794 145.203 C 10.755 145.735 11.817 146 12.877 146 C 14.049 146 15.219 145.676 16.248 145.033 L 118.011 81.432 C 119.87 80.27 121 78.232 121 76.039 C 121 73.846 119.87 71.808 118.011 70.645 L 16.248 7.043 C 14.287 5.818 11.816 5.753 9.794 6.874 C 7.772 7.995 6.517 10.125 6.517 12.437 L 6.517 139.64 C 6.517 141.952 7.772 144.082 9.794 145.203 Z " fill="rgb(73,139,29)" />
                                        </g>
                                    </svg>
                                    <strong>&nbsp;Sem Produção</strong>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer />
        </div>
    )
}
export default ZonePage